<template>
  <header class="title">
    <div>
      <div class="logo" @click="home" style="padding: 0;">
        <el-row>
          <img src="@/assets/images/topLogo.png" alt="">
        </el-row>
      </div>
      <div class="nav">
        <ul class="flex align-center justify-around">
          <li v-for="(item, index) in navList" :key="index" :class="{active: navActive === item.name }" @click="route(item, index)">
            <!--<el-dropdown trigger="hover" v-if="index === 7">-->
						<!--	<span class="el-dropdown-link">-->
						<!--		{{ item.title }}-->
						<!--	</span>-->
            <!--  <el-dropdown-menu slot="dropdown">-->
            <!--    <el-dropdown-item v-for="(item, index) in dropdownItem" :key="index">-->
            <!--      <p @click="dropdown(item, index)"> {{ item.title }}</p>-->
            <!--    </el-dropdown-item>-->
            <!--  </el-dropdown-menu>-->
            <!--</el-dropdown>-->
            <span>
							{{ item.title }}
						</span>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import '@/assets/css/index.less'
import {menus} from "@/utils/mack";

export default {
  name: 'index',
  data() {
    return {
      navActive: 'index',
      dropdownItem: [
        {
          path: '/jdapply',
          name: '鉴定申请',

        },
        {
          path: '/jgmap',
          name: '鉴定机构地址查询'
        },
        {
          path: '/jdfw?type=4',
          name: '鉴定机构管理平台'
        },
        {
          path: 'questions',
          name: '问题咨询'
        }
      ],
      navList: [],
      dataList: [
        '鉴定申请', '鉴定机构地址查询', '鉴定机构管理平台', '问题咨询'
      ],
    }
  },
  watch: {
    '$route'(to, from) {
      this.navActive = to.name
    }
  },
  mounted() {
    this.navList = menus
  },
  methods: {
    home() {
      this.$router.push('/')
    },
    // 导航跳转
    route(item) {
      this.$router.push(item.path)
      this.navActive = item.name
    },
    // 产品栏目菜单切换
    dropdown(item, index) {
      if (index === 2) {
        window.location.href = 'https://ajsl.hb.sfjdzx.org.cn/'
        return false;
      } else if (index === 1) {
        this.$router.push('/jgmap')
        return false;
      } else if (index === 0) {
        if (localStorage.getItem('token')) {
          this.$router.push('/grht')
          return false;
        }
      }
      this.$router.push(item.path)
    }
  },
};
</script>
